Pixlee.module('VerticalApp.Show', function(Show, App, _Backbone, _Marionette, $) {
    var headerHeight;

    Show.Layout = App.Views.Layout.extend({
        template: require('./templates/layout.jst.ejs'),
        regions: {
            widget_header_region: '#widget_header_region',
            interactive_region: '#interactive_region',
            frame: '.vertical_frame'
        },
        ui: {
            vertical_frame: '.vertical_frame',
            vertical_widget: '#vertical_widget',
            widget_header_region: '#widget_header_region',
            interactive_region: '#interactive_region'
        },
        onShow: function() {
            window.addEventListener('resize', this.sendMessage);
        },
        initialize: function() {
            var _this = this;
            this.displayOptions = App.displayOptions;
            var resize = function(size) {
                headerHeight = _this.ui.widget_header_region.css('height').replace('px', '');
                var controlButtonHeight = 100;
                _this.ui.vertical_widget.css('height', size - headerHeight);
                _this.ui.vertical_frame.css('height', size - controlButtonHeight - headerHeight);
            };

            var receiveMessage = function(event) {
                try {
                    var eventData = JSON.parse(event.data);
                    if (eventData.name === 'pixlee:resize:widget') {
                        var height = eventData.data.height;
                        var width = eventData.data.width;
                        resize(height);
                    }
                } catch (e) {
                    // console.log('invalid json');
                    return;
                }

            };
            window.addEventListener('message', receiveMessage, false);
        },
        sendMessage: function() {
            var message = {
                name: 'pixlee:widget:shape',
                type: 'action',
                source: 'widget',
                destination: 'parent',
                data: {
                    type: 'vertical'
                }
            };
            window.parent.postMessage(JSON.stringify(message), '*');
        }
    });

    Show.Layout.include(['LayoutHelpers', 'AccessibilityHelpers']);

    Show.PhotoView = App.Views.ItemView.extend({
        getTemplate: function() {
            var photoQuality = gon.display_options && gon.display_options.photoQuality || 'default';
            if (App.isDesktop && (photoQuality === 'xl' || photoQuality === 'original')) {
                return require('../common/templates/v2/_xl_photo_item.jst.ejs');
            } else {
                return require('../common/templates/v2/_photo_item.jst.ejs');
            }
        },
        className: 'photo_block',
        tagName: 'li',
        behaviors: {
            Reviews: {},
            Share: {},
            Vote: {},
            Lightbox: {},
            UpdateThumbnailCss: {}
        },
        initialize: function() {
            if (this.model.get('is_starred')) {
                this.$el.addClass('starred');
            }
        },
        templateHelpers: {
            decodeUtf8: function(string) {
                return App.request('decode:utf8', string);
            }
        }
    });
    Show.PhotoView.include(['PhotoViewHelpers', 'ReviewHelpers']);

    // Photowall View
    Show.VerticalCollection = App.Views.CollectionView.extend({
        childView: Show.PhotoView,
        className: 'clearfix',
        tagName: 'ul',
        behaviors: function() {
            var behaviorHash = {
                CollectionVote: {},
            };
            if (App.isDesktop) {
                behaviorHash.RefreshOnCssGenerated = {};
            }

            // for backwards compatibility with widgets that are already out in the wild
            if (!_.isFalsy(this.options.displayOptions.headerOptions)) {
                behaviorHash.AppendUploaderTiles = {};
            }
            // if there's no upload tiles or if hideIfLessThanIsSet is set, then we need to have the ability to hide empty albums
            var noUploadButton = _.isFalsy(this.options.displayOptions.headerOptions.end_tile_upload_button_background_showHide);
            var setHideIfLessThan = !_.isFalsy(App.displayOptions.get('hideIfLessThan')) || !_.isFalsy(gon.current_account.extra_fields.hideIfLessThan);
            if (noUploadButton || setHideIfLessThan) {
                behaviorHash.HideEmptyAlbumWidget = {};
            }

            return behaviorHash;
        },
        initialize: function() {
            this.collection.reviewSelectionOptions = {
                currentModelIndex: 0
            };
        },
        onShow: function() {
            $('#widget').attr('alt', App.altText);
            this.setNextPageListener();
        },
        fetchNextPage: function(extraFnc) {
            var _this = this;
            this.isFetching = true;

            this.collection.nextPage({
                success: function(collection) {
                    if (collection.next) {
                        $('.next').removeClass('disabled');
                    }
                    _this.isFetching = false;
                    _this.sly.reload({
                        silentScroll: true
                    });
                    if (extraFnc) {
                        extraFnc.call(_this, _this.sly.items[1].center, true);
                    }
                }
            });
        },
        setNextPageListener: function() {
            var _this = this;
            //only send events on clicks not auto resize
            $('.next, .prev').click(function() {
                _this.initialLoad = false;
                if (_this.collection.length === 1) {
                    _this.initialLoad = true;
                    _this.fetchNextPage(_this.sly.slideTo);
                }
            });
        },
        forceCenterSly: function(middleItemIndex) {
            // Re-initalizes with forcedCenter and activateMiddle
            var _this = this;
            var verticalFrame = $('.vertical_frame');
            this.isFetching = false;
            this.initialLoad = true;

            var slyOptions = this.getSlyOptions();
            slyOptions.itemNav = 'forceCentered';
            slyOptions.activateMiddle = 1;
            slyOptions.startAt = middleItemIndex;
            var setAccessibleElements = this.setAccessibleElements.bind(this);

            this.sly = new Sly(verticalFrame, slyOptions, {
                'change': function() {
                    var position = $(this)[0].pos;
                    if (!_this.initialLoad) {
                        if (position.dest > position.cur) {
                            App.commands.execute('nav:right', this.rel, _this.collection);
                        } else {
                            App.commands.execute('nav:left', this.rel, _this.collection);
                        }
                    }

                    if (!_this.initialLoad && position.dest / position.end > 0.6 && !_this.isFetching) {
                        _this.fetchNextPage();
                        _this.initialLoad = true;
                    }
                },
                'move': function() {
                    setAccessibleElements();
                }
            }).init();
            this.setAccessibleElements();
        },
        getSlyOptions: function() {
            return {
                horizontal: 0,
                smart: 1,
                itemNav: 'centered',
                activateOn: 'click',
                mouseDragging: 0,
                touchDragging: 1,
                releaseSwing: 1,
                startAt: 0,
                scrollBy: 0,
                speed: 300,
                elasticBounds: 1,
                easing: 'easeOutExpo',
                prevPage: $('.prev'),
                nextPage: $('.next')
            };
        },
        initializeSly: function() {
            var _this = this;
            var debouncedDragNav = _.debounce(function(position, e) {
                var ev = e ? e.type : 'badEvent';
                var userInteractions = ['touchstart', 'touchend', 'touchmove', 'click'];

                //200 is a magic number but it's about 2 photos in the general case. we don't really need to be
                //that accurate here, other than preventing a tiny jolt from firing it off
                if (Math.abs(position.cur - this.oldPosition) < 200 || userInteractions.indexOf(ev) < 0) {
                    return;
                } else if (position.cur > this.oldPosition) {
                    App.commands.execute('nav:right', this.sly.rel, this.collection);
                } else {
                    App.commands.execute('nav:left', this.sly.rel, this.collection);
                }
                this.oldPosition = position.cur;
            }.bind(this), 250);
            var setAccessibleElements = this.setAccessibleElements.bind(this);

            if (this.collection.length) {
                var verticalFrame = $('.vertical_frame');
                this.sly = new Sly(verticalFrame, this.getSlyOptions(), {
                    'change': function() {
                        var position = $(this)[0].pos;
                        if (App.isDesktop) {
                            if (!_this.initialLoad) {
                                if (position.dest > position.cur) {
                                    App.commands.execute('nav:right', this.rel, _this.collection);
                                } else {
                                    App.commands.execute('nav:left', this.rel, _this.collection);
                                }
                            }
                        } else {
                            if (position.cur !== 0) {
                                //some dumb things don't know what event is, so make sure it's defined
                                var eventObj = !_.isFalsy(typeof event) ? event : null;
                                debouncedDragNav(position, eventObj);
                            }
                        }
                        if ((!_this.initialLoad && App.isDesktop) || (!App.isDesktop && position.cur !== 0) && position.dest / position.end > 0.6 && !_this.isFetching) {
                            _this.isFetching = true;
                            _this.collection.nextPage({
                                success: function(collection) {
                                    if (App.isDesktop && collection.next) {
                                        $('.next').removeClass('disabled');
                                    }
                                    _this.isFetching = false;
                                    _this.sly.reload({
                                        silentScroll: true
                                    });
                                }
                            });
                        }
                    },
                    'move': function() {
                        setAccessibleElements();
                    }
                }).init();
                this.setAccessibleElements();

                try {
                    if (this.collection.length && !App.isDesktop) {
                        // If there are not enough photos to fill the frame
                        if (this.sly.items[this.sly.items.length - 1].end < 0) {
                            this.centerSly();
                        }
                    } else {
                        // If there are not enough photos to fill the frame
                        var lastItem = this.sly.items[this.sly.items.length - 1];
                        // Since end can be 0 on init, manually calculate it
                        var calculatedEnd = lastItem.start + lastItem.size;
                        if (calculatedEnd <= 0) {
                            this.centerSly();
                        }
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        },
        centerSly: function() {
            var middleItemIndex = Math.ceil(this.sly.items.length / 2) - 1;
            this.sly.destroy();
            delete this.sly;
            this.forceCenterSly(middleItemIndex);
        },
        onRender: function() {
            this.isFetching = false;
            this.initialLoad = true;
            this.oldPosition = 0;

            if (this.sly) {
                this.sly.destroy();
                delete this.sly;
            }

            this.initializeSly();
        }
    });
    Show.VerticalCollection.include(['tabindexHelpers', 'designEditorCollectionHelpers', 'socialShareHelpers']);

    Show.HeaderView = App.Views.ItemView.extend({
        template: require('../common/templates/v2/_header.jst.ejs'),
        id: 'widget_header',
        behaviors: {
            Upload: {},
            ShowPdpCaption: {}
        },
        onShow: function() {
            headerHeight = $(this.el).height();
        }
    });

    Show.HeaderView.include(['StandaloneHeaderHelpers']);

});
